<script>
  import RouteDialogMixin from './RouteDialogMixin';


  export default {
    name: 'Dialog',

    mixins: [
      RouteDialogMixin
    ],

    data() {
      return {
        dialogOpened: false,
        routePath: null
      };
    },

    watch: {
      dialogOpened(dialogOpened) {
        if (this.routePath) {
          return; // Body background handled by App.vue
        }

        if (!dialogOpened) {
          return this._setBackground(this._prevBodyBackground);
        }

        // `dialogOpened` is `true`.
        try {
          const bodyBgColor = window.getComputedStyle(document.body).backgroundColor;
          let [bR, bG, bB] = this._parseRgbaString(bodyBgColor);

          const overlayColor = 'rgba(33, 33, 33, 0.46)';
          let [oR, oG, oB, oA] = this._parseRgbaString(overlayColor);

          // Calculate computed color.
          // https://stackoverflow.com/a/12228643
          const cR = bR + (oR - bR) * oA;
          const cG = bG + (oG - bG) * oA;
          const cB = bB + (oB - bB) * oA;
          const computedColor = `rgb(${[cR, cG, cB].join(', ')})`;

          this._prevBodyBackground = this.$store.getters['share/getBodyBackground'];
          this._setBackground(computedColor);

        } catch (error) {
          /* NOOP - Do not update the body background. */
        }
      }
    },

    destroyed() {
      if (!this.routePath && this.dialogOpened) {
        this._setBackground(this._prevBodyBackground); // Fix if [HMR].
      }
    },

    methods: {
      show() {
        this.dialogOpened = true;
      },

      hide() {
        this.dialogOpened = false;
      },

      toggle() {
        this.dialogOpened = !this.dialogOpened;
      },

      focus() {
        const {dialog} = this.$refs;
        if (dialog) {
          dialog.$nextTick(() => dialog.$refs.content.focus());
        } else {
          // eslint-disable-next-line no-console
          console.warn('Could not focus dialog. `$ref.dialog` not found.');
        }
      },

      _setBackground(background) {
        this.$store.commit('share/setBodyBackground', background);
      },

      /**
       * Parse RGBA String
       * @param {string} rgbaString e.g. 'rgb(255, 255, 255)', 'rgba(255, 255, 255, 0.8)'
       * @return {Array} Array of rgba colors e.g. [255, 255, 255, 1]
       */
      _parseRgbaString(rgbaString) {
        const colors = rgbaString
          // Remove 'rgb[a](' at start, ')' at the end & all whitespaces.
          .replace(/(^rgb(a?)\(|\)$)|(\s)/g, '')
          .split(',')
          .map((c) => parseFloat(c));

        if (colors[3] === undefined) { // alpha
          colors[3] = 1;
        }

        return colors;
      }
    }
  };
</script>

<style scoped>
  .v-card__title {
    font-size: 18px !important;
  }
</style>
